import React from "react";
import {
  StyledHeading,
  StyledHighlightedText,
  StyledSubText,
  StyledTextContainer,
} from "./style";
import { useSelector } from "react-redux";

const WelcomeBannerFont = () => {
  const profileDetails = useSelector((state) => state?.auth?.profileDetails);

  return (
    <StyledTextContainer>
      <StyledSubText>
        Hi{" "}
        <StyledHighlightedText>
          {profileDetails?.name ||
            (profileDetails?.first_name || "") +
              " " +
              (profileDetails?.last_name || "").trim()}
        </StyledHighlightedText>
        ,
      </StyledSubText>
      <StyledHeading>Welcome Back</StyledHeading>
    </StyledTextContainer>
  );
};

export default WelcomeBannerFont;
